import React from 'react';
import { VendorGetStaticProps } from 'vendor/utils/VendorGetStaticProps';
import { StaticPageCode } from 'src/common/models/staticPage';
import { StaticPage } from 'src/public/components/static-page/StaticPage';
import { getStaticPage } from 'src/common/services/staticPage';
import { getStaticPageQueryKey } from 'src/common/hooks/staticPage/useStaticPageQuery';
import getConfig from 'next/config';

const staticPageCode = StaticPageCode.CookiesPolicy;

export const CookiesPolicyPage = () => (
  <StaticPage code={staticPageCode} title="Polityka Cookies" />
);

export const getStaticProps = VendorGetStaticProps(async (ctx) => {
  const serverConfig = getConfig().serverRuntimeConfig;

  await ctx.queryClient.prefetchQuery(getStaticPageQueryKey(staticPageCode), () =>
    getStaticPage(staticPageCode),
  );

  return {
    props: {},
    revalidate: serverConfig.staticPage.revalidate,
  };
});

export default CookiesPolicyPage;
